/*globals $*/
'use strict';

const getValidationFunctions = () => import("./validate");
var typingTimer;
var doneTypingInterval = 600;

$( document ).ready(function() {

    $('#hundreds__contact-form #hundreds__contact_submit-button').on('click', function(e){
        console.log('contact');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateContactForm();
        });
    });

    $('#hundreds__newsletter-form #hundreds__newsletter_submit-button').on('click', function(e){
        console.log('newsletter');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateNewsletterForm();
        });
    });

    $('#hundreds__search-form #hundreds__search-form_input').on('keyup', function(e){
        var search = $(this).val();

        clearTimeout(typingTimer);
        if ( $(this).val() ) {
            $('#hundreds__search-loader').removeClass('search-window__loader_hidden', 600, "easeInBack");
            if( search.length >= 3 ){
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            }
        }else{
            $('#hundreds__search-loader').addClass('search-window__loader_hidden', 600, "easeInBack");
            hideSearchResults();
        }
    });

});

function doneTyping () {
    setTimeout(function(){ 
        getValidationFunctions().then(validateModule => {
            validateModule.validateSearchForm();
        });
    }, 600);
    
}

function hideSearchResults()
{
    $('.search-window__results-item').addClass('search-window__results-item_hidden',600, "easeInBack");
}

